import {Middleware, isRejected, isRejectedWithValue, AnyAction} from '@reduxjs/toolkit'

export const errorLoggerCreator =
    <AppState>({
        callbackActionError,
        callbackSliceError,
    }: {
        callbackActionError?: (argument: {
            state: AppState
            action: AnyAction & {
                error?: {
                    code?: string
                    message?: string
                    stack?: string
                }
            }
        }) => void
        callbackSliceError?: (argument: {state: AppState; action: AnyAction; error: Maybe<Error>}) => void
    }): Middleware<AppState> =>
    ({getState}) =>
    (next) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action: any) => {
        if (action) {
            if (!isRejectedWithValue(action) && isRejected(action)) {
                if (callbackActionError && action.error) {
                    callbackActionError({
                        state: getState(),
                        action,
                    })
                }
            }
        }
        try {
            next(action)
        } catch (e) {
            // slice error catch
            if (callbackSliceError) {
                callbackSliceError({
                    state: getState(),
                    action,
                    error: e instanceof Error ? e : null,
                })
            }
            throw e
        }
    }
